export default __webpack_public_path__ + "static/media/E-ValuateName.60a237df.png";